export enum FundraiserTypeEnum {
  'unknown' = -1,
  'Minnesgåva' = 1,
  'Gåva' = 2,
  'Högtidsgåva' = 3,
  'Insamling' = 4,
}

export const getFundraiserTypeText = (type: FundraiserTypeEnum, t: (n: string) => string): string => {
  return t(`fundraiser:fundraiserTypeText.${type}`) || t('invoice:invoiceDeliveryMethodString.unknown');
};
